import {
  createRouter as createVueRouter,
  createWebHistory,
  Router,
} from 'vue-router';
import UserLogin from '@login/pages/UserLogin.vue';

export function createRouter(): Router {
  return createVueRouter({
    routes: [
      {
        path: '/login',
        name: 'UserLogin',
        component: UserLogin,
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/login',
      },
    ],
    history: createWebHistory(import.meta.env.BASE_URL),
  });
}
